import React from "react";
import { Carousel } from "react-responsive-carousel";

const ImageCarousel = (props) => (
  <Carousel
    autoPlay={props.autoPlay}
    infiniteLoop={props.infiniteLoop}
    showArrows={props.showArrows}
    showStatus={props.showStatus}
    showThumbs={props.showThumbs}
    showIndicators={props.showIndicators}
    interval={props.interval || 0}
    className={props.className}
  >
    {props.children}
  </Carousel>
);

export default ImageCarousel;
